import { Button, Flex } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { isShipmentCalculatedOnActual } from '../../../../../helpers/entities/shipment/get-shipment-display-calculated'
import { DataSourceItem } from '../../../shipments-page'
import PlanFactComparisonModal from '../../plan-fact-comparison-modal/plan-fact-comparison-modal'
import RunShipment from './run-shipment/run-shipment'

interface IdProps {
    data: DataSourceItem
}

const IdLink = styled(Button)`
    && {
        padding: 0;
        height: auto;
        line-height: inherit;
    }
`

const Id: FC<IdProps> = ({ data }) => {
    const [open, setOpen] = useState(false)
    const canCompare = isShipmentCalculatedOnActual(data)

    return (
        <>
            <Flex justify={'space-between'}>
                {canCompare ? (
                    <IdLink type="link" onClick={() => setOpen(true)}>
                        {data?.id}
                    </IdLink>
                ) : (
                    <span>{data?.id}</span>
                )}

                <RunShipment data={data} />
            </Flex>
            {open && (
                <PlanFactComparisonModal
                    open={open}
                    shipment={data}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    )
}

export default Id
